export class DeialogIaNa {
    teitl: string;
    neges: string;
    botwmna: string;
    botwmia: string;
    eicon: string;
    negesGwall: string | null;

    constructor(teitl: string, neges: string, botwmna: string, botwmia: string, eicon: string, negesGwall?: string) {
        this.teitl = teitl;
        this.neges = neges;
        this.botwmna = botwmna;
        this.botwmia = botwmia;
        this.eicon = eicon;
        this.negesGwall = negesGwall;
    }
}
